import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Light from 'components/headers/light';
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

const PointsPage = () => {
  // Initialisation de l'état avec les 4 statistiques requises
  const [data, setData] = useState({ 
    total_amount: 0,      // Total des achats
    points_en_cours: 0,   // Points en cours (en attente)
    points: 0,            // Points actifs (disponibles)
    valeur_dh: 0          // Valeur équivalente en DH
  });

  // --- LOGIQUE D'EXTRACTION DU CUSTOM_ID ---
  const userStr = localStorage.getItem("user");
  const userData = userStr ? JSON.parse(userStr) : null;
  const customId = userData ? userData.custom_id : null;
  // -----------------------------------------

  useEffect(() => {
    if (customId) {
      // Appel vers ton API loyalty
      axios.get(`https://rehabwmg.online/api/loyalty/${customId}`)
        .then(res => {
          // Gestion dynamique de la réponse API (clés alternatives si calculées côté front)
          const pointsActifs = res.data.points || res.data.points_actifs || 0;
          const valeurDH = res.data.valeur_dh || (pointsActifs * 10);

          setData({
            total_amount: res.data.total_amount || res.data.total_achats || 0,
            points_en_cours: res.data.points_en_cours || 0,
            points: pointsActifs,
            valeur_dh: valeurDH
          });
        })
        .catch(err => console.error("Erreur API Loyalty:", err));
    }
  }, [customId]);

  const handleGetPromoCode = () => {
    Swal.fire({
      title: "Votre Récompense Fidélité",
      html: `
        <p>Vous avez <strong>${data.points} points actifs</strong>.</p>
        <p>Remise disponible : <strong>${data.valeur_dh} DH</strong></p>
        <hr style="border-top: 1px dashed #ccc;">
        <p>Utilisez votre Code Promo lors du paiement :</p>
        <h2 style="color: #4e7662; font-weight: bold; letter-spacing: 1px;">${customId}</h2>
      `,
      icon: "success",
      confirmButtonText: "Fermer",
      confirmButtonColor: "#4e7662"
    });
  };

  return (
    <AnimationRevealPage>
      <Light />
      <div className="container mt-5 mb-5">
        <div className="card shadow-sm border-0" style={{ borderRadius: "15px" }}>
          <div className="card-body text-center p-5">
            <h3 className="fw-bold mb-5" style={{ color: "#333" }}>Mes Points de Fidélité</h3>
            
            {/* Grille responsive des 4 statistiques */}
            <div className="row g-4">
              
              {/* 1. Total des Achats */}
              <div className="col-md-3 col-sm-6">
                <div className="p-3 bg-light rounded h-100">
                  <h6 className="text-muted text-uppercase small fw-bold">Total des Achats</h6>
                  <p className="fs-3 fw-bold mt-2 mb-0" style={{ color: "#2d3748" }}>
                    {parseFloat(data.total_amount).toFixed(2)} <span style={{ fontSize: "0.9rem" }}>DH</span>
                  </p>
                </div>
              </div>

              {/* 2. Points en Cours */}
              <div className="col-md-3 col-sm-6">
                <div className="p-3 bg-light rounded h-100">
                  <h6 className="text-muted text-uppercase small fw-bold">Points en Cours</h6>
                  <p className="fs-3 fw-bold mt-2 mb-0" style={{ color: "#e67e22" }}>
                    {data.points_en_cours} <span style={{ fontSize: "0.9rem" }}>PTS</span>
                  </p>
                  <small className="text-muted d-block mt-1" style={{ fontSize: "0.75rem" }}>En attente de livraison</small>
                </div>
              </div>

              {/* 3. Points Actifs */}
              <div className="col-md-3 col-sm-6">
                <div className="p-3 bg-light rounded h-100">
                  <h6 className="text-muted text-uppercase small fw-bold">Points Actifs</h6>
                  <p className="fs-3 fw-bold mt-2 mb-0" style={{ color: "#28a745" }}>
                    {data.points} <span style={{ fontSize: "0.9rem" }}>PTS</span>
                  </p>
                  <small className="text-muted d-block mt-1" style={{ fontSize: "0.75rem" }}>Disponibles</small>
                </div>
              </div>

              {/* 4. Valeur en DH */}
              <div className="col-md-3 col-sm-6">
                <div className="p-3 bg-light rounded h-100">
                  <h6 className="text-muted text-uppercase small fw-bold">Valeur en DH</h6>
                  <p className="fs-3 fw-bold mt-2 mb-0" style={{ color: "#4e7662" }}>
                    {data.valeur_dh}.00 <span style={{ fontSize: "0.9rem" }}>DH</span>
                  </p>
                  <small className="text-muted d-block mt-1" style={{ fontSize: "0.75rem" }}>Réduction applicable</small>
                </div>
              </div>

            </div>

            {customId ? (
              <button 
                className="btn btn-lg mt-5 px-5 py-3 fw-bold shadow-sm" 
                style={{ 
                  backgroundColor: "#4e7662", 
                  color: "white", 
                  borderRadius: "30px",
                  fontSize: "1rem"
                }}
                onClick={handleGetPromoCode}
              >
                PRENDRE MON CODE DE REMISE
              </button>
            ) : (
              <div className="alert alert-warning mt-5">
                Veuillez vous reconnecter pour accéder à vos points.
              </div>
            )}
          </div>
        </div>
      </div>
    </AnimationRevealPage>
  );
};

export default PointsPage;